<div class="tabbed">
  <div class="pane-header">
    <h3 class="title">Select Image</h3>
    <div class="segments">
      <nav role="tablist" class="tab-selectors tab-selectors--primary edit-form-nav">
        <label class="tab-selector tab-selector--first" for="image-edit" role="tab">
          <input class="tab-selector-radio" type="radio" value="image-edit" id="image-edit" name="image-dialog-tab" data-behaviour="tabstate" aria-controls="image-edit-tab">
          <span class="tab-label">Edit</span>
        </label>
        <label class="tab-selector" for="image-search" role="tab">
          <input class="tab-selector-radio" type="radio" value="image-search" id="image-search" name="image-dialog-tab" data-behaviour="tabstate" aria-controls="image-search-tab">
          <span class="tab-label">Library</span>
        </label>
        <label class="tab-selector tab-selector--last" for="image-upload" role="tab">
          <input class="tab-selector-radio" type="radio" value="image-upload" id="image-upload" name="image-dialog-tab" data-behaviour="tabstate" aria-controls="image-upload-tab">
          <span class="tab-label">Upload</span>
        </label>
      </nav>
    </div>
    <div class="actions">
      <span class="close">
        {{{ icon 'close' 'Close' }}}
      </span>
    </div>
  </div>
  <div class="pane-body">
    <div id="image-edit-tab" class="image-edit-tab" role="tabpanel">
      <div class="image-placeholder">Please select an image to edit</div>
    </div>

    <div id="image-search-tab" class="image-search-tab" role="tabpanel">
      <input type="text" placeholder="Search" name="query" autocomplete="off">
      <ul class="results"></ul>
    </div>

    <div id="image-upload-tab" class="upload-file-tab image-upload-tab" role="tabpanel">
      {{{ icon 'upload-color' 'Upload' }}}
      <p class="upload-file-tab__upload-instructions">
        Drag and drop files here or 
        <span class="upload-file-tab__file-upload-button">
          <button>click to upload</button>
          <input type="file" name="files" />
        </span>

      </p>
      <p>
        <small class="upload-file-tab__file-size-limit">Limit individual file sizes to 300kb or less.</small>
      </p>
    </div>

    <div id="upload-progress-tab" class="upload-progress-tab" style="display: none;">
      <h2>Uploading File</h2>
      <div class="progress-container"></div>
      <button>Cancel</button>
    </div>
  </div>
  <div class="pane-footer">
  </div>
</div>
